import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./firebase_initialization";
import { logPageView } from "./analytics_utils";

const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      logPageView(location.pathname);
    }
  }, [location]);

  return null;
};

export default PageViewTracker;
